import React, { useState } from 'react';
import { Modal, Button, Table, Form, Row, Col } from 'react-bootstrap';

interface modalProps {
  show: any;
  onHide: any;
}

const BuscarProdutoModal: React.FC<modalProps> = ({ show, onHide }) => {
  const [produtos, setProdutos] = useState([
    { codigo: '38818-P-007387', descricao: 'BLOCO MANIFOLD TN10 01-AS', tam: 'U', un: 'UN', referencia: 'TN10-01', preco: '1,000', estoque: '0,00', codBarras: '' },
    { codigo: '38818-P-007386', descricao: 'BLOCO MANIFOLDTN6 01-AS', tam: 'U', un: 'UN', referencia: 'TN6-01', preco: '1,000', estoque: '0,00', codBarras: '' },
    // Adicione mais produtos aqui conforme necessário
  ]);

  const [busca, setBusca] = useState('');
  const [quantidade, setQuantidade] = useState('1,000');

  return (
    <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
      <Modal.Header closeButton style={{ background: 'linear-gradient(#f8f9fa, #d6d8db)' }}>
        <Modal.Title>Buscar Produto</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col md={8}>
            <Form.Label>Produtos</Form.Label>
            <Form.Control
              type="text"
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
              placeholder="Digite para buscar produto..."
            />
          </Col>
          <Col md={4}>
            <Form.Label>Quantidade</Form.Label>
            <Form.Control
              type="text"
              value={quantidade}
              onChange={(e) => setQuantidade(e.target.value)}
            />
          </Col>
        </Row>

        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <Table bordered hover size="sm">
            <thead className="table-light">
              <tr>
                <th>CÓDIGO</th>
                <th>DESCRIÇÃO</th>
                <th>TAM</th>
                <th>UN</th>
                <th>REFERÊNCIA</th>
                <th>PREÇO</th>
                <th>ESTOQUE</th>
                <th>CÓDIGO BARRAS</th>
              </tr>
            </thead>
            <tbody>
              {produtos.map((produto, idx) => (
                <tr key={idx}>
                  <td>{produto.codigo}</td>
                  <td>{produto.descricao}</td>
                  <td>{produto.tam}</td>
                  <td>{produto.un}</td>
                  <td>{produto.referencia}</td>
                  <td>{produto.preco}</td>
                  <td>{produto.estoque}</td>
                  <td>{produto.codBarras}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={() => console.log('Selecionado')}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default BuscarProdutoModal